var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: { active: _vm.isNavOpened },
      attrs: { id: "burger" },
      on: {
        click: function($event) {
          $event.preventDefault()
          return _vm.toggleNav()
        }
      }
    },
    [
      _vm._t("default", function() {
        return [
          _c("div", { staticClass: "burger-container" }, [
            _c(
              "button",
              {
                staticClass: "burger-button",
                attrs: { title: "Menu", type: "button" }
              },
              [
                _c("span", {
                  staticClass: "burger-bar burger-bar--1",
                  class: _vm.color
                }),
                _c("span", {
                  staticClass: "burger-bar burger-bar--2",
                  class: _vm.color
                }),
                _c("span", {
                  staticClass: "burger-bar burger-bar--3",
                  class: _vm.color
                })
              ]
            )
          ]),
          _vm.showTitle && !_vm.isNavOpened
            ? _c("label", { staticClass: "burger-bar-text" }, [
                _vm._v(" Menú ")
              ])
            : _vm._e(),
          _vm.showTitle && _vm.isNavOpened
            ? _c("label", { staticClass: "burger-bar-text" }, [
                _vm._v(" Cerrar ")
              ])
            : _vm._e()
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }